module.exports = {"title":"Passwort vergessen","resetPasswordButton":"Passwort zurücksetzen","meta":"Passwort zurücksetzen"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/de/recover.json
// module id = DdbF
// module chunks = 1